<template>
  <v-card class="elevation-0" light rounded="xl">
    <v-card-text class="black--text">
      <div class="pb-8 mt-4">
        <v-img
          height="50"
          contain
          src="@/assets/images/logo/logo-dark.png"
          alt=""
        />
      </div>
      <div class="d-flex flex-wrap justify-space-around gap-12">
        <div style="max-width: 320px">
          <router-link to="/terms/contract">
            <div class="d-flex">
              <div class="text-start">
                <div class="d-flex pb-3 justify-space-between align-center">
                  <h5 class="mb-0">Termos & Condições</h5>
                  <v-icon medium>mdi-arrow-right</v-icon>
                </div>
                <p class="black--text">
                  Leia nossos termos para entender os direitos e
                  responsabilidades. Ao utilizar nosso serviço, você concorda
                  com estas condições.
                </p>
              </div>
            </div>
          </router-link>
        </div>
        <div style="max-width: 320px">
          <router-link to="/terms/privacy">
            <div class="d-flex">
              <div class="text-start">
                <div class="d-flex pb-3 justify-space-between align-center">
                  <h5 class="mb-0">Política de Privacidade</h5>
                  <v-icon medium>mdi-arrow-right</v-icon>
                </div>
                <p class="black--text">
                  Priorizamos sua privacidade e a proteção de seus dados. Leia
                  nossa política para saber como suas informações são
                  utilizadas.
                </p>
              </div>
            </div>
          </router-link>
        </div>
        <!-- <div style="max-width: 320px">
          <router-link to="/terms/concession">
            <div class="d-flex">
              <div class="text-start">
                <div class="d-flex pb-3 justify-space-between align-center">
                  <h5 class="mb-0">Política de Meia Entrada</h5>
                  <v-icon medium>mdi-arrow-right</v-icon>
                </div>
                <p class="black--text">
                  Leia nossa política de meia entrada para saber como ela funciona.
                </p>
              </div>
            </div>
          </router-link>
        </div> -->
      </div>
      <div class="d-flex flex-column align-center pt-7 pb-4">
        <b class="black--text text-13 mb-0 lh-1">
          {{ legalInfo.fantasyName || legalInfo.name }}
        </b>
        <small class="black--text text-12 mb-0">
          {{ legalInfo.document }}
        </small>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { texts, legalInfo } from "@/themeConfig.js";
export default {
  name: "OpenAIComponent",
  data() {
    return {
      texts,
      legalInfo,
    };
  },
  methods: {
    goToContract() {
      this.$router.push({ name: "terms.contract" });
    },
    goToPrivacy() {
      this.$router.push({ name: "terms.privacy" });
    },
  },
};
</script>

<style scoped>
.transparent {
  background-color: transparent !important;
}

.fill-height {
  border-radius: 10px;
}
</style>
